import React from "react";
import { Table } from "react-bootstrap";
import { formatDate } from "../config/function";

const PaymentHistoryList = ({ paymentHistory, type }) => {
    const history = paymentHistory || [];
    const filterHistory =type==='Normal'? paymentHistory.filter((pau)=>pau.nor_advance_deduction !== 0):paymentHistory.filter((pau)=>pau.res_advance_deduction !== 0);
    return (
        <Table className="table">
            <thead>
                <tr>
                    <th>S.No</th>
                    <th>Date</th>
                    {/* <th>Trip Count</th> */}
                    {/* <th>Total Amount</th> */}
                    <th>{type} Advance Deduction</th>
                    {/* <th>Paid Amount</th> */}
                    {/* <th>Remarks</th> */}
                </tr>
            </thead>
            <tbody>
                {filterHistory.length > 0 ? (
                    filterHistory.map((p, i) => (
                        <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{formatDate(p.payment_date)}</td>
                            {/* <td>{p.trip_count}</td> */}
                            {/* <td>{p.total_amount}</td> */}
                            <td style={{ textAlign: 'left' }}>{(type === 'Normal' ? p.nor_advance_deduction :p.res_advance_deduction).toFixed(2)}</td>
                            {/* <td>{p.paid_amount}</td> */}
                            {/* <td>{p.remarks}</td> */}
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={7}>No payment history found</td>
                    </tr>
                )}
            </tbody>
        </Table>
    );
};


export default PaymentHistoryList;
